import "./styles/App.css";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import Navbar from "./components/UI/Navbar/Navbar";
import AppRouter from "./components/AppRouter";
import { useEffect, useState } from "react";
import { AuthContext } from "./context";
import { VariableProvider } from "./context/VariableContext";
// import 

function App() {
  useEffect(() => {
    
  }, 
  []);
  return (
    <VariableProvider>
      <BrowserRouter>
        
        {/* <Navbar /> */}
        <AppRouter />

      </BrowserRouter>
    </VariableProvider>
  );
}

export default App;
